export const EQUALS_3DS_ERROR_MESSAGES_BY_CODE = {
  // Validation errors
  MISSING_FIELDS: {
    en: 'Missing required fields: {fields}',
    fr: 'Champs obligatoires manquants : {fields}',
  },
  // Business/service errors
  CHALLENGE_NOT_FOUND: {
    en: '3DS challenge not found or expired',
    fr: 'Challenge 3DS introuvable ou expiré',
  },
  // OTP errors (via validate_3ds)
  OTP_INVALID_CODE: {
    en: 'Invalid code. Remaining attempts: {n}',
    fr: 'Code invalide. Tentatives restantes : {n}',
  },
  OTP_ALREADY_USED: {
    en: 'Code has already been used',
    fr: 'Le code a déjà été utilisé',
  },
  OTP_MAX_ATTEMPTS: {
    en: 'Maximum attempts exceeded',
    fr: 'Nombre maximum de tentatives dépassé',
  },
  OTP_EXPIRED: {
    en: 'Code has expired',
    fr: 'Le code a expiré',
  },
  OTP_NOT_FOUND: {
    en: 'OTP not found',
    fr: 'Code OTP introuvable',
  },
  OTP_SYSTEM_ERROR: {
    en: 'An error occurred. Please try again later.',
    fr: 'Une erreur est survenue. Veuillez réessayer plus tard.',
  },
};

function normalizeLocale(locale) {
  return locale === 'en' ? 'en' : 'fr';
}

function interpolate(template, params) {
  if (!template || !params) return template;
  return template.replace(/\{(\w+)\}/g, (m, k) => {
    const v = params[k];
    if (v === undefined || v === null) return m;
    if (Array.isArray(v)) return v.join(', ');
    return String(v);
  });
}

function parseRemainingAttemptsFromMessage(error) {
  const msg =
    error?.message || error?.msg || error?.error_message || error?.errorMessage;
  if (!msg) return undefined;

  // EN: "Remaining attempts: 2"
  const en = String(msg).match(/remaining attempts\s*:\s*(\d+)/i);
  if (en?.[1]) return Number(en[1]);

  // FR: "Tentatives restantes : 2"
  const fr = String(msg).match(/tentatives restantes\s*:\s*(\d+)/i);
  if (fr?.[1]) return Number(fr[1]);

  return undefined;
}

function extractParams(error) {
  const ctx = error?.error_context || error?.context || {};

  const fields =
    error?.fields ??
    ctx?.fields ??
    ctx?.missing_fields ??
    ctx?.missingFields ??
    undefined;

  const n =
    error?.n ??
    error?.remaining_attempts ??
    error?.remainingAttempts ??
    ctx?.n ??
    ctx?.remaining_attempts ??
    ctx?.remainingAttempts ??
    parseRemainingAttemptsFromMessage(error) ??
    undefined;

  return {fields, n};
}

export function isEquals3dsApi(api) {
  if (typeof api !== 'string') return false;
  // FE may call `company/<id>/equals/3ds-validation...` or `equals/3ds-validation`
  return api.includes('equals/3ds-validation');
}

/**
 * Resolve message for typical failing HTTP responses (callAPI reject path).
 */
export function resolveEquals3dsErrorMessage({api, error, locale} = {}) {
  const loc = normalizeLocale(locale);
  const code = error?.error_code || error?.code || error?.errorCode;
  if (!code) return null;
  if (!isEquals3dsApi(api)) return null;

  const msg = EQUALS_3DS_ERROR_MESSAGES_BY_CODE?.[code]?.[loc];
  if (!msg) return null;
  return interpolate(msg, extractParams(error));
}
